<template>
    <div class="white-container">
        <div v-if="ponderationActive">
            <div class="row vertical-center space-between w-100 mt-20px" v-for="(globalQuestion, index) in globalQuestions"
                :key="index">
                <div class="col-15 mr-10px">
                    <img :src="globalQuestion.icon" class="img-global" />
                </div>
                <div class="col-80 row space-between ">
                    <div class="col-50">
                        <div class="label-type">{{ globalQuestion.label }}</div>
                        <div class="paragraph">{{ globalQuestion.description }}</div>
                    </div>
                    <div class="position-relative col-50">
                        <input type="number" class="calculators-input-round w-100"
                            v-model="results[globalQuestion.label]" @input="$emit('update:modelValue', results);checkError()">
                        <div v-if="globalQuestion.unit" class="big-input-unit">{{ globalQuestion.unit }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <h2 class="title-gen" v-if="transportTitle">Transports</h2>
            <p class="paragraph" v-if="commentTransport">{{ commentTransport }}</p>
            <div class="row align-form">
                <div v-for="(transportsQuestion, index) in transportsQuestions" :key="index" class="col-50">
                    <div class="d-flex space-between align-form">
                        <div class="col-15">
                            <img :src="transportsQuestion.icon" class="w-100" />
                        </div>
                        <div class="col-80">
                            <label class="label-calculators" v-html="transportsQuestion.label"></label>
                            <div class="position-relative">
                                <input type="number" class="calculator-input-square w-100" style="padding-right: 70px;"
                                    v-model="results[transportsQuestion.label]"
                                    @input="$emit('update:modelValue', results); checkError()">
                                <div v-if="smallUnit" class="small-input-unit" v-html="smallUnit"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex vertical-center d-flex-end  mt-15px" v-if="smallUnit === '%'">
                <label class="label-total-input">Total</label>
                <div>
                    <div class="position-relative">
                        <input class="total-input-square w-100" type="number" :value="totalPercent" readonly />
                        <div class="total-input-percent-square">%</div>

                    </div>
                    <div class="error" v-html="error"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            results: {},
            error: null
        }
    },
    props: {
        ponderationActive: { type: Boolean, default: true },
        smallUnit: { type: String, default: '%' },
        globalQuestions: Array,
        transportsQuestions: Array,
        commentTransport: String,
        modelValue: Object,
        transportTitle: { type: Boolean, default: true },
    },
    computed: {
        totalPercent() {
            let total = 0
            Object.keys(this.results).forEach(element => {
                if (this.transportsQuestions.find(question => question.label == element)) {
                    if(this.results[element]){
                        total += parseFloat(this.results[element])
                    }
                }
            })
            return total
        }
    },
    methods: {
        checkError() {
            this.error=''
            if (this.smallUnit === '%') {
                this.globalQuestions.forEach(element=>{
                    if(!this.results[element.label]){
                        this.error += 'Vous devez remplir le champ '+element.label +'<br/>'
                    }
                })
                if (this.totalPercent !== 100) {
                    this.error += 'Le total de pourcentage doit être 100%'
                    
                }
                if(this.error){
                    this.$emit('onError', true)
                }
                else {
                    this.$emit('onError', false)
                }
            }

        }
    },
    watch: {
        modelValue(newVal) {
            this.results = newVal;
        }
    }
}
</script>
<style scoped>
.label-type {
    color: var(--text-color);
    font-family: var(--font);
    font-size: 32px;
    font-style: normal;
    font-weight: 900;
    line-height: 33.2px;
    /* 103.75% */
}
.big-input-unit {
    position: absolute;
    top: 50%;
    right: 5%;
    transform: translateY(-50%);
    color: #BAB1B1;
    font-family: var(--font);
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.img-global {
    width: 95%;
}

.small-input-unit {
    position: absolute;
    top: 50%;
    right: 5%;
    transform: translateY(-50%);
    color: var(--text-color);
    font-family: var(--font);
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28.2px;
    /* 141% */
}

@media screen and (max-width: 1500px) {
    .col-15 {
        width: 20%;
    }
    .col-80 {
        width: 75%;
    }

    .label-calculators {
        font-size: 24px;
    }
    .calculators-input-round{
        padding: 15px 25px;
    }
}
@media screen and (max-width: 1300px) {
    .col-15 {
        width: 20%;
    }
    .col-80 {
        width: 80%;
    }
    .label-type{
        font-size: 25px;
    }
}
@media screen and (max-width: 992px) {
    .big-input-unit{
        font-size: 25px;
    }
    .calculators-input-round{
        font-size: 20px;
        padding:15px 20px;
    }
}
@media screen and (max-width: 750px) {
  .col-50{
    width:100%;
  }
  .label-calculators {
        font-size: 20px;
    }
    .title-gen{
        font-size: 30px;
    }
}
@media screen and (max-width: 600px) {
    .distance-calculator-container h2 {
        font-size: 25px;
    }

    .distance-calculator-container {
        padding: 5px 10px;
    }

    .big-input-unit {
        right:25px;
        font-size: 20px;
    }
}
</style>